import React, { useState, useEffect } from 'react';
import './marketing/marketing.css';
import {
  Nav,
  Hero,
  VSL,
  BookCall,
  ThreeJobs,
  Calculator,
  Stats,
  VideoTestimonials,
  Videos,
  FAQ,
  FinalCTA,
  Footer,
} from './marketing/MarketingComponents';
import Imprint from './components/Imprint';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Cookies from './components/Cookies';
import SMSTerms from './components/SMSTerms';
import CookieBanner from './components/CookieBanner';

// Hash routes for the legal subpages. Anchors that should still scroll the
// home page (e.g. #vsl, #faq) are not listed here and fall through to the
// main marketing layout.
const LEGAL_ROUTES = {
  '#privacy': Privacy,
  '#terms': Terms,
  '#cookies': Cookies,
  '#sms-terms': SMSTerms,
  '#legal-notice': Imprint,
  '#imprint': Imprint,
};

function App() {
  const [currentHash, setCurrentHash] = useState('');

  useEffect(() => {
    setCurrentHash(window.location.hash);
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
      // When landing on a legal page from a link click, scroll to the top so
      // the user starts at the page heading rather than wherever the previous
      // scroll position left them.
      if (LEGAL_ROUTES[window.location.hash]) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const LegalPage = LEGAL_ROUTES[currentHash];
  if (LegalPage) {
    return (
      <>
        <Nav minimal />
        <LegalPage />
        <Footer minimal />
        <CookieBanner />
      </>
    );
  }

  return (
    <>
      <Nav />
      <Hero />
      <VSL />
      <BookCall />
      <ThreeJobs />
      <Calculator />
      <Stats />
      <VideoTestimonials />
      <Videos />
      <FAQ />
      <FinalCTA />
      <Footer />
      <CookieBanner />
    </>
  );
}

export default App;
